import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import PaiButton from 'features/ui/base-components/pai-button';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;
  loading: boolean;
  contactCount: number;

  handleClose(): void;

  handleDeleteMultipleContactsPermanently(): void;
}

const DeleteMultipleContactsPermanentlyDialog: React.FC<Props> = ({
  open,
  loading,
  contactCount,
  handleClose,
  handleDeleteMultipleContactsPermanently,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} transitionDuration={0} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('deleteMultipleContactsPermanently')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={1}>
          <Typography className={classes.text}>
            <Trans i18nKey={'confirmDeleteMultipleContacts'} values={{ contactCount }}>
              Should the <strong>{contactCount}</strong> contacts really be permanently removed from the campaign?
            </Trans>
          </Typography>
          <Typography className={classes.text}>{t('deletedContactsInfo')}</Typography>
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton text={t('ok')} action={handleDeleteMultipleContactsPermanently} size={'small'} border={'rounded'} loading={loading} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: `linear-gradient(to right, ${theme.palette.warning.main}, ${theme.palette.warning.light})`,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '20px 24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default DeleteMultipleContactsPermanentlyDialog;
